import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import rootReducers from './rootReducers'
import rootSagas from './rootSagas'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'settings', 'shared']
}

const persistedReducer = persistReducer(persistConfig, rootReducers)

const sagaMiddleware = createSagaMiddleware()

const store = createStore(
  persistedReducer,
  applyMiddleware(
    sagaMiddleware
  )
)
sagaMiddleware.run(rootSagas)

const persistor = persistStore(store)

export default { store, persistor }



// WEBPACK FOOTER //
// ./src/store/index.js